module.exports = __webpack_public_path__ + "static/logo-paypal-94035774d513a45ecba940f074851be4.png";